"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubitem1Sentence = exports.isSubitem1Title = exports.isSubitem1 = exports.isItemSentence = exports.isItemTitle = exports.isItem = exports.isClassSentence = exports.isClassTitle = exports.isClass = exports.isNewProvision = exports.isAmendProvisionSentence = exports.isAmendProvision = exports.isSupplNote = exports.isParagraphSentence = exports.isParagraphNum = exports.isParagraphCaption = exports.isParagraph = exports.isArticleCaption = exports.isArticleTitle = exports.isArticle = exports.isDivisionTitle = exports.isDivision = exports.isSubsectionTitle = exports.isSubsection = exports.isSectionTitle = exports.isSection = exports.isChapterTitle = exports.isChapter = exports.isPartTitle = exports.isPart = exports.isMainProvision = exports.isPreamble = exports.isArticleRange = exports.isTOCAppdxTableLabel = exports.isTOCSupplProvision = exports.isTOCArticle = exports.isTOCDivision = exports.isTOCSubsection = exports.isTOCSection = exports.isTOCChapter = exports.isTOCPart = exports.isTOCPreambleLabel = exports.isTOCLabel = exports.isTOC = exports.isEnactStatement = exports.isLawTitle = exports.isLawBody = exports.isLawNum = exports.isLaw = exports.isControl = void 0;
exports.isTableStruct = exports.isAppdxFigTitle = exports.isAppdxFig = exports.isArithFormula = exports.isArithFormulaNum = exports.isAppdx = exports.isAppdxFormatTitle = exports.isAppdxFormat = exports.isAppdxStyleTitle = exports.isAppdxStyle = exports.isAppdxNoteTitle = exports.isAppdxNote = exports.isAppdxTableTitle = exports.isAppdxTable = exports.isSupplProvisionAppdx = exports.isSupplProvisionAppdxStyleTitle = exports.isSupplProvisionAppdxStyle = exports.isSupplProvisionAppdxTableTitle = exports.isSupplProvisionAppdxTable = exports.isSupplProvisionLabel = exports.isSupplProvision = exports.isColumn = exports.isSentence = exports.isSubitem10Sentence = exports.isSubitem10Title = exports.isSubitem10 = exports.isSubitem9Sentence = exports.isSubitem9Title = exports.isSubitem9 = exports.isSubitem8Sentence = exports.isSubitem8Title = exports.isSubitem8 = exports.isSubitem7Sentence = exports.isSubitem7Title = exports.isSubitem7 = exports.isSubitem6Sentence = exports.isSubitem6Title = exports.isSubitem6 = exports.isSubitem5Sentence = exports.isSubitem5Title = exports.isSubitem5 = exports.isSubitem4Sentence = exports.isSubitem4Title = exports.isSubitem4 = exports.isSubitem3Sentence = exports.isSubitem3Title = exports.isSubitem3 = exports.isSubitem2Sentence = exports.isSubitem2Title = exports.isSubitem2 = void 0;
exports.makeIsStdEL = exports.isStdEL = exports.newStdEL = exports.defaultAttrs = exports.stdELTags = exports.isSub = exports.isSup = exports.isLine = exports.isRt = exports.isRuby = exports.isQuoteStruct = exports.isSublist3Sentence = exports.isSublist3 = exports.isSublist2Sentence = exports.isSublist2 = exports.isSublist1Sentence = exports.isSublist1 = exports.isListSentence = exports.isList = exports.isRemarksLabel = exports.isRemarks = exports.isRelatedArticleNum = exports.isFormat = exports.isFormatStructTitle = exports.isFormatStruct = exports.isStyle = exports.isStyleStructTitle = exports.isStyleStruct = exports.isNote = exports.isNoteStructTitle = exports.isNoteStruct = exports.isFig = exports.isFigStructTitle = exports.isFigStruct = exports.isTableColumn = exports.isTableHeaderColumn = exports.isTableHeaderRow = exports.isTableRow = exports.isTable = exports.isTableStructTitle = void 0;
const el_1 = require("../../node/el");
const isControl = (obj) => {
    return (typeof obj !== "string") && obj.isControl;
};
exports.isControl = isControl;
const isLaw = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Law");
};
exports.isLaw = isLaw;
const defaultAttrOfLaw = {};
const isLawNum = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "LawNum");
};
exports.isLawNum = isLawNum;
const defaultAttrOfLawNum = {};
const isLawBody = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "LawBody");
};
exports.isLawBody = isLawBody;
const defaultAttrOfLawBody = {};
const isLawTitle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "LawTitle");
};
exports.isLawTitle = isLawTitle;
const defaultAttrOfLawTitle = {};
const isEnactStatement = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "EnactStatement");
};
exports.isEnactStatement = isEnactStatement;
const defaultAttrOfEnactStatement = {};
const isTOC = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "TOC");
};
exports.isTOC = isTOC;
const defaultAttrOfTOC = {};
const isTOCLabel = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "TOCLabel");
};
exports.isTOCLabel = isTOCLabel;
const defaultAttrOfTOCLabel = {};
const isTOCPreambleLabel = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "TOCPreambleLabel");
};
exports.isTOCPreambleLabel = isTOCPreambleLabel;
const defaultAttrOfTOCPreambleLabel = {};
const isTOCPart = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "TOCPart");
};
exports.isTOCPart = isTOCPart;
const defaultAttrOfTOCPart = {
    Delete: "false",
};
const isTOCChapter = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "TOCChapter");
};
exports.isTOCChapter = isTOCChapter;
const defaultAttrOfTOCChapter = {
    Delete: "false",
};
const isTOCSection = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "TOCSection");
};
exports.isTOCSection = isTOCSection;
const defaultAttrOfTOCSection = {
    Delete: "false",
};
const isTOCSubsection = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "TOCSubsection");
};
exports.isTOCSubsection = isTOCSubsection;
const defaultAttrOfTOCSubsection = {
    Delete: "false",
};
const isTOCDivision = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "TOCDivision");
};
exports.isTOCDivision = isTOCDivision;
const defaultAttrOfTOCDivision = {
    Delete: "false",
};
const isTOCArticle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "TOCArticle");
};
exports.isTOCArticle = isTOCArticle;
const defaultAttrOfTOCArticle = {
    Delete: "false",
};
const isTOCSupplProvision = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "TOCSupplProvision");
};
exports.isTOCSupplProvision = isTOCSupplProvision;
const defaultAttrOfTOCSupplProvision = {};
const isTOCAppdxTableLabel = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "TOCAppdxTableLabel");
};
exports.isTOCAppdxTableLabel = isTOCAppdxTableLabel;
const defaultAttrOfTOCAppdxTableLabel = {};
const isArticleRange = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "ArticleRange");
};
exports.isArticleRange = isArticleRange;
const defaultAttrOfArticleRange = {};
const isPreamble = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Preamble");
};
exports.isPreamble = isPreamble;
const defaultAttrOfPreamble = {};
const isMainProvision = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "MainProvision");
};
exports.isMainProvision = isMainProvision;
const defaultAttrOfMainProvision = {};
const isPart = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Part");
};
exports.isPart = isPart;
const defaultAttrOfPart = {
    Delete: "false",
    Hide: "false",
};
const isPartTitle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "PartTitle");
};
exports.isPartTitle = isPartTitle;
const defaultAttrOfPartTitle = {};
const isChapter = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Chapter");
};
exports.isChapter = isChapter;
const defaultAttrOfChapter = {
    Delete: "false",
    Hide: "false",
};
const isChapterTitle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "ChapterTitle");
};
exports.isChapterTitle = isChapterTitle;
const defaultAttrOfChapterTitle = {};
const isSection = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Section");
};
exports.isSection = isSection;
const defaultAttrOfSection = {
    Delete: "false",
    Hide: "false",
};
const isSectionTitle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "SectionTitle");
};
exports.isSectionTitle = isSectionTitle;
const defaultAttrOfSectionTitle = {};
const isSubsection = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subsection");
};
exports.isSubsection = isSubsection;
const defaultAttrOfSubsection = {
    Delete: "false",
    Hide: "false",
};
const isSubsectionTitle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "SubsectionTitle");
};
exports.isSubsectionTitle = isSubsectionTitle;
const defaultAttrOfSubsectionTitle = {};
const isDivision = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Division");
};
exports.isDivision = isDivision;
const defaultAttrOfDivision = {
    Delete: "false",
    Hide: "false",
};
const isDivisionTitle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "DivisionTitle");
};
exports.isDivisionTitle = isDivisionTitle;
const defaultAttrOfDivisionTitle = {};
const isArticle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Article");
};
exports.isArticle = isArticle;
const defaultAttrOfArticle = {
    Delete: "false",
    Hide: "false",
};
const isArticleTitle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "ArticleTitle");
};
exports.isArticleTitle = isArticleTitle;
const defaultAttrOfArticleTitle = {};
const isArticleCaption = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "ArticleCaption");
};
exports.isArticleCaption = isArticleCaption;
const defaultAttrOfArticleCaption = {};
const isParagraph = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Paragraph");
};
exports.isParagraph = isParagraph;
const defaultAttrOfParagraph = {
    OldStyle: "false",
    OldNum: "false",
    Hide: "false",
};
const isParagraphCaption = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "ParagraphCaption");
};
exports.isParagraphCaption = isParagraphCaption;
const defaultAttrOfParagraphCaption = {};
const isParagraphNum = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "ParagraphNum");
};
exports.isParagraphNum = isParagraphNum;
const defaultAttrOfParagraphNum = {};
const isParagraphSentence = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "ParagraphSentence");
};
exports.isParagraphSentence = isParagraphSentence;
const defaultAttrOfParagraphSentence = {};
const isSupplNote = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "SupplNote");
};
exports.isSupplNote = isSupplNote;
const defaultAttrOfSupplNote = {};
const isAmendProvision = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "AmendProvision");
};
exports.isAmendProvision = isAmendProvision;
const defaultAttrOfAmendProvision = {};
const isAmendProvisionSentence = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "AmendProvisionSentence");
};
exports.isAmendProvisionSentence = isAmendProvisionSentence;
const defaultAttrOfAmendProvisionSentence = {};
const isNewProvision = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "NewProvision");
};
exports.isNewProvision = isNewProvision;
const defaultAttrOfNewProvision = {};
const isClass = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Class");
};
exports.isClass = isClass;
const defaultAttrOfClass = {};
const isClassTitle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "ClassTitle");
};
exports.isClassTitle = isClassTitle;
const defaultAttrOfClassTitle = {};
const isClassSentence = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "ClassSentence");
};
exports.isClassSentence = isClassSentence;
const defaultAttrOfClassSentence = {};
const isItem = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Item");
};
exports.isItem = isItem;
const defaultAttrOfItem = {
    Delete: "false",
    Hide: "false",
};
const isItemTitle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "ItemTitle");
};
exports.isItemTitle = isItemTitle;
const defaultAttrOfItemTitle = {};
const isItemSentence = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "ItemSentence");
};
exports.isItemSentence = isItemSentence;
const defaultAttrOfItemSentence = {};
const isSubitem1 = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem1");
};
exports.isSubitem1 = isSubitem1;
const defaultAttrOfSubitem1 = {
    Delete: "false",
    Hide: "false",
};
const isSubitem1Title = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem1Title");
};
exports.isSubitem1Title = isSubitem1Title;
const defaultAttrOfSubitem1Title = {};
const isSubitem1Sentence = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem1Sentence");
};
exports.isSubitem1Sentence = isSubitem1Sentence;
const defaultAttrOfSubitem1Sentence = {};
const isSubitem2 = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem2");
};
exports.isSubitem2 = isSubitem2;
const defaultAttrOfSubitem2 = {
    Delete: "false",
    Hide: "false",
};
const isSubitem2Title = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem2Title");
};
exports.isSubitem2Title = isSubitem2Title;
const defaultAttrOfSubitem2Title = {};
const isSubitem2Sentence = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem2Sentence");
};
exports.isSubitem2Sentence = isSubitem2Sentence;
const defaultAttrOfSubitem2Sentence = {};
const isSubitem3 = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem3");
};
exports.isSubitem3 = isSubitem3;
const defaultAttrOfSubitem3 = {
    Delete: "false",
    Hide: "false",
};
const isSubitem3Title = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem3Title");
};
exports.isSubitem3Title = isSubitem3Title;
const defaultAttrOfSubitem3Title = {};
const isSubitem3Sentence = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem3Sentence");
};
exports.isSubitem3Sentence = isSubitem3Sentence;
const defaultAttrOfSubitem3Sentence = {};
const isSubitem4 = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem4");
};
exports.isSubitem4 = isSubitem4;
const defaultAttrOfSubitem4 = {
    Delete: "false",
    Hide: "false",
};
const isSubitem4Title = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem4Title");
};
exports.isSubitem4Title = isSubitem4Title;
const defaultAttrOfSubitem4Title = {};
const isSubitem4Sentence = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem4Sentence");
};
exports.isSubitem4Sentence = isSubitem4Sentence;
const defaultAttrOfSubitem4Sentence = {};
const isSubitem5 = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem5");
};
exports.isSubitem5 = isSubitem5;
const defaultAttrOfSubitem5 = {
    Delete: "false",
    Hide: "false",
};
const isSubitem5Title = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem5Title");
};
exports.isSubitem5Title = isSubitem5Title;
const defaultAttrOfSubitem5Title = {};
const isSubitem5Sentence = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem5Sentence");
};
exports.isSubitem5Sentence = isSubitem5Sentence;
const defaultAttrOfSubitem5Sentence = {};
const isSubitem6 = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem6");
};
exports.isSubitem6 = isSubitem6;
const defaultAttrOfSubitem6 = {
    Delete: "false",
    Hide: "false",
};
const isSubitem6Title = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem6Title");
};
exports.isSubitem6Title = isSubitem6Title;
const defaultAttrOfSubitem6Title = {};
const isSubitem6Sentence = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem6Sentence");
};
exports.isSubitem6Sentence = isSubitem6Sentence;
const defaultAttrOfSubitem6Sentence = {};
const isSubitem7 = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem7");
};
exports.isSubitem7 = isSubitem7;
const defaultAttrOfSubitem7 = {
    Delete: "false",
    Hide: "false",
};
const isSubitem7Title = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem7Title");
};
exports.isSubitem7Title = isSubitem7Title;
const defaultAttrOfSubitem7Title = {};
const isSubitem7Sentence = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem7Sentence");
};
exports.isSubitem7Sentence = isSubitem7Sentence;
const defaultAttrOfSubitem7Sentence = {};
const isSubitem8 = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem8");
};
exports.isSubitem8 = isSubitem8;
const defaultAttrOfSubitem8 = {
    Delete: "false",
    Hide: "false",
};
const isSubitem8Title = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem8Title");
};
exports.isSubitem8Title = isSubitem8Title;
const defaultAttrOfSubitem8Title = {};
const isSubitem8Sentence = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem8Sentence");
};
exports.isSubitem8Sentence = isSubitem8Sentence;
const defaultAttrOfSubitem8Sentence = {};
const isSubitem9 = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem9");
};
exports.isSubitem9 = isSubitem9;
const defaultAttrOfSubitem9 = {
    Delete: "false",
    Hide: "false",
};
const isSubitem9Title = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem9Title");
};
exports.isSubitem9Title = isSubitem9Title;
const defaultAttrOfSubitem9Title = {};
const isSubitem9Sentence = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem9Sentence");
};
exports.isSubitem9Sentence = isSubitem9Sentence;
const defaultAttrOfSubitem9Sentence = {};
const isSubitem10 = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem10");
};
exports.isSubitem10 = isSubitem10;
const defaultAttrOfSubitem10 = {
    Delete: "false",
    Hide: "false",
};
const isSubitem10Title = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem10Title");
};
exports.isSubitem10Title = isSubitem10Title;
const defaultAttrOfSubitem10Title = {};
const isSubitem10Sentence = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Subitem10Sentence");
};
exports.isSubitem10Sentence = isSubitem10Sentence;
const defaultAttrOfSubitem10Sentence = {};
const isSentence = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Sentence");
};
exports.isSentence = isSentence;
const defaultAttrOfSentence = {
    WritingMode: "vertical",
};
const isColumn = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Column");
};
exports.isColumn = isColumn;
const defaultAttrOfColumn = {
    LineBreak: "false",
};
const isSupplProvision = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "SupplProvision");
};
exports.isSupplProvision = isSupplProvision;
const defaultAttrOfSupplProvision = {};
const isSupplProvisionLabel = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "SupplProvisionLabel");
};
exports.isSupplProvisionLabel = isSupplProvisionLabel;
const defaultAttrOfSupplProvisionLabel = {};
const isSupplProvisionAppdxTable = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "SupplProvisionAppdxTable");
};
exports.isSupplProvisionAppdxTable = isSupplProvisionAppdxTable;
const defaultAttrOfSupplProvisionAppdxTable = {};
const isSupplProvisionAppdxTableTitle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "SupplProvisionAppdxTableTitle");
};
exports.isSupplProvisionAppdxTableTitle = isSupplProvisionAppdxTableTitle;
const defaultAttrOfSupplProvisionAppdxTableTitle = {
    WritingMode: "vertical",
};
const isSupplProvisionAppdxStyle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "SupplProvisionAppdxStyle");
};
exports.isSupplProvisionAppdxStyle = isSupplProvisionAppdxStyle;
const defaultAttrOfSupplProvisionAppdxStyle = {};
const isSupplProvisionAppdxStyleTitle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "SupplProvisionAppdxStyleTitle");
};
exports.isSupplProvisionAppdxStyleTitle = isSupplProvisionAppdxStyleTitle;
const defaultAttrOfSupplProvisionAppdxStyleTitle = {
    WritingMode: "vertical",
};
const isSupplProvisionAppdx = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "SupplProvisionAppdx");
};
exports.isSupplProvisionAppdx = isSupplProvisionAppdx;
const defaultAttrOfSupplProvisionAppdx = {};
const isAppdxTable = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "AppdxTable");
};
exports.isAppdxTable = isAppdxTable;
const defaultAttrOfAppdxTable = {};
const isAppdxTableTitle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "AppdxTableTitle");
};
exports.isAppdxTableTitle = isAppdxTableTitle;
const defaultAttrOfAppdxTableTitle = {
    WritingMode: "vertical",
};
const isAppdxNote = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "AppdxNote");
};
exports.isAppdxNote = isAppdxNote;
const defaultAttrOfAppdxNote = {};
const isAppdxNoteTitle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "AppdxNoteTitle");
};
exports.isAppdxNoteTitle = isAppdxNoteTitle;
const defaultAttrOfAppdxNoteTitle = {
    WritingMode: "vertical",
};
const isAppdxStyle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "AppdxStyle");
};
exports.isAppdxStyle = isAppdxStyle;
const defaultAttrOfAppdxStyle = {};
const isAppdxStyleTitle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "AppdxStyleTitle");
};
exports.isAppdxStyleTitle = isAppdxStyleTitle;
const defaultAttrOfAppdxStyleTitle = {
    WritingMode: "vertical",
};
const isAppdxFormat = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "AppdxFormat");
};
exports.isAppdxFormat = isAppdxFormat;
const defaultAttrOfAppdxFormat = {};
const isAppdxFormatTitle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "AppdxFormatTitle");
};
exports.isAppdxFormatTitle = isAppdxFormatTitle;
const defaultAttrOfAppdxFormatTitle = {
    WritingMode: "vertical",
};
const isAppdx = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Appdx");
};
exports.isAppdx = isAppdx;
const defaultAttrOfAppdx = {};
const isArithFormulaNum = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "ArithFormulaNum");
};
exports.isArithFormulaNum = isArithFormulaNum;
const defaultAttrOfArithFormulaNum = {};
const isArithFormula = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "ArithFormula");
};
exports.isArithFormula = isArithFormula;
const defaultAttrOfArithFormula = {};
const isAppdxFig = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "AppdxFig");
};
exports.isAppdxFig = isAppdxFig;
const defaultAttrOfAppdxFig = {};
const isAppdxFigTitle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "AppdxFigTitle");
};
exports.isAppdxFigTitle = isAppdxFigTitle;
const defaultAttrOfAppdxFigTitle = {
    WritingMode: "vertical",
};
const isTableStruct = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "TableStruct");
};
exports.isTableStruct = isTableStruct;
const defaultAttrOfTableStruct = {};
const isTableStructTitle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "TableStructTitle");
};
exports.isTableStructTitle = isTableStructTitle;
const defaultAttrOfTableStructTitle = {
    WritingMode: "vertical",
};
const isTable = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Table");
};
exports.isTable = isTable;
const defaultAttrOfTable = {
    WritingMode: "vertical",
};
const isTableRow = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "TableRow");
};
exports.isTableRow = isTableRow;
const defaultAttrOfTableRow = {};
const isTableHeaderRow = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "TableHeaderRow");
};
exports.isTableHeaderRow = isTableHeaderRow;
const defaultAttrOfTableHeaderRow = {};
const isTableHeaderColumn = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "TableHeaderColumn");
};
exports.isTableHeaderColumn = isTableHeaderColumn;
const defaultAttrOfTableHeaderColumn = {};
const isTableColumn = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "TableColumn");
};
exports.isTableColumn = isTableColumn;
const defaultAttrOfTableColumn = {
    BorderTop: "solid",
    BorderBottom: "solid",
    BorderLeft: "solid",
    BorderRight: "solid",
};
const isFigStruct = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "FigStruct");
};
exports.isFigStruct = isFigStruct;
const defaultAttrOfFigStruct = {};
const isFigStructTitle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "FigStructTitle");
};
exports.isFigStructTitle = isFigStructTitle;
const defaultAttrOfFigStructTitle = {};
const isFig = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Fig");
};
exports.isFig = isFig;
const defaultAttrOfFig = {};
const isNoteStruct = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "NoteStruct");
};
exports.isNoteStruct = isNoteStruct;
const defaultAttrOfNoteStruct = {};
const isNoteStructTitle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "NoteStructTitle");
};
exports.isNoteStructTitle = isNoteStructTitle;
const defaultAttrOfNoteStructTitle = {};
const isNote = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Note");
};
exports.isNote = isNote;
const defaultAttrOfNote = {};
const isStyleStruct = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "StyleStruct");
};
exports.isStyleStruct = isStyleStruct;
const defaultAttrOfStyleStruct = {};
const isStyleStructTitle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "StyleStructTitle");
};
exports.isStyleStructTitle = isStyleStructTitle;
const defaultAttrOfStyleStructTitle = {};
const isStyle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Style");
};
exports.isStyle = isStyle;
const defaultAttrOfStyle = {};
const isFormatStruct = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "FormatStruct");
};
exports.isFormatStruct = isFormatStruct;
const defaultAttrOfFormatStruct = {};
const isFormatStructTitle = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "FormatStructTitle");
};
exports.isFormatStructTitle = isFormatStructTitle;
const defaultAttrOfFormatStructTitle = {};
const isFormat = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Format");
};
exports.isFormat = isFormat;
const defaultAttrOfFormat = {};
const isRelatedArticleNum = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "RelatedArticleNum");
};
exports.isRelatedArticleNum = isRelatedArticleNum;
const defaultAttrOfRelatedArticleNum = {};
const isRemarks = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Remarks");
};
exports.isRemarks = isRemarks;
const defaultAttrOfRemarks = {};
const isRemarksLabel = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "RemarksLabel");
};
exports.isRemarksLabel = isRemarksLabel;
const defaultAttrOfRemarksLabel = {
    LineBreak: "false",
};
const isList = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "List");
};
exports.isList = isList;
const defaultAttrOfList = {};
const isListSentence = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "ListSentence");
};
exports.isListSentence = isListSentence;
const defaultAttrOfListSentence = {};
const isSublist1 = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Sublist1");
};
exports.isSublist1 = isSublist1;
const defaultAttrOfSublist1 = {};
const isSublist1Sentence = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Sublist1Sentence");
};
exports.isSublist1Sentence = isSublist1Sentence;
const defaultAttrOfSublist1Sentence = {};
const isSublist2 = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Sublist2");
};
exports.isSublist2 = isSublist2;
const defaultAttrOfSublist2 = {};
const isSublist2Sentence = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Sublist2Sentence");
};
exports.isSublist2Sentence = isSublist2Sentence;
const defaultAttrOfSublist2Sentence = {};
const isSublist3 = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Sublist3");
};
exports.isSublist3 = isSublist3;
const defaultAttrOfSublist3 = {};
const isSublist3Sentence = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Sublist3Sentence");
};
exports.isSublist3Sentence = isSublist3Sentence;
const defaultAttrOfSublist3Sentence = {};
const isQuoteStruct = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "QuoteStruct");
};
exports.isQuoteStruct = isQuoteStruct;
const defaultAttrOfQuoteStruct = {};
const isRuby = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Ruby");
};
exports.isRuby = isRuby;
const defaultAttrOfRuby = {};
const isRt = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Rt");
};
exports.isRt = isRt;
const defaultAttrOfRt = {};
const isLine = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Line");
};
exports.isLine = isLine;
const defaultAttrOfLine = {
    Style: "solid",
};
const isSup = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Sup");
};
exports.isSup = isSup;
const defaultAttrOfSup = {};
const isSub = (obj) => {
    return (typeof obj !== "string") && (obj.tag === "Sub");
};
exports.isSub = isSub;
const defaultAttrOfSub = {};
exports.stdELTags = [
    "Law",
    "LawNum",
    "LawBody",
    "LawTitle",
    "EnactStatement",
    "TOC",
    "TOCLabel",
    "TOCPreambleLabel",
    "TOCPart",
    "TOCChapter",
    "TOCSection",
    "TOCSubsection",
    "TOCDivision",
    "TOCArticle",
    "TOCSupplProvision",
    "TOCAppdxTableLabel",
    "ArticleRange",
    "Preamble",
    "MainProvision",
    "Part",
    "PartTitle",
    "Chapter",
    "ChapterTitle",
    "Section",
    "SectionTitle",
    "Subsection",
    "SubsectionTitle",
    "Division",
    "DivisionTitle",
    "Article",
    "ArticleTitle",
    "ArticleCaption",
    "Paragraph",
    "ParagraphCaption",
    "ParagraphNum",
    "ParagraphSentence",
    "SupplNote",
    "AmendProvision",
    "AmendProvisionSentence",
    "NewProvision",
    "Class",
    "ClassTitle",
    "ClassSentence",
    "Item",
    "ItemTitle",
    "ItemSentence",
    "Subitem1",
    "Subitem1Title",
    "Subitem1Sentence",
    "Subitem2",
    "Subitem2Title",
    "Subitem2Sentence",
    "Subitem3",
    "Subitem3Title",
    "Subitem3Sentence",
    "Subitem4",
    "Subitem4Title",
    "Subitem4Sentence",
    "Subitem5",
    "Subitem5Title",
    "Subitem5Sentence",
    "Subitem6",
    "Subitem6Title",
    "Subitem6Sentence",
    "Subitem7",
    "Subitem7Title",
    "Subitem7Sentence",
    "Subitem8",
    "Subitem8Title",
    "Subitem8Sentence",
    "Subitem9",
    "Subitem9Title",
    "Subitem9Sentence",
    "Subitem10",
    "Subitem10Title",
    "Subitem10Sentence",
    "Sentence",
    "Column",
    "SupplProvision",
    "SupplProvisionLabel",
    "SupplProvisionAppdxTable",
    "SupplProvisionAppdxTableTitle",
    "SupplProvisionAppdxStyle",
    "SupplProvisionAppdxStyleTitle",
    "SupplProvisionAppdx",
    "AppdxTable",
    "AppdxTableTitle",
    "AppdxNote",
    "AppdxNoteTitle",
    "AppdxStyle",
    "AppdxStyleTitle",
    "AppdxFormat",
    "AppdxFormatTitle",
    "Appdx",
    "ArithFormulaNum",
    "ArithFormula",
    "AppdxFig",
    "AppdxFigTitle",
    "TableStruct",
    "TableStructTitle",
    "Table",
    "TableRow",
    "TableHeaderRow",
    "TableHeaderColumn",
    "TableColumn",
    "FigStruct",
    "FigStructTitle",
    "Fig",
    "NoteStruct",
    "NoteStructTitle",
    "Note",
    "StyleStruct",
    "StyleStructTitle",
    "Style",
    "FormatStruct",
    "FormatStructTitle",
    "Format",
    "RelatedArticleNum",
    "Remarks",
    "RemarksLabel",
    "List",
    "ListSentence",
    "Sublist1",
    "Sublist1Sentence",
    "Sublist2",
    "Sublist2Sentence",
    "Sublist3",
    "Sublist3Sentence",
    "QuoteStruct",
    "Ruby",
    "Rt",
    "Line",
    "Sup",
    "Sub",
];
exports.defaultAttrs = {
    Law: defaultAttrOfLaw,
    LawNum: defaultAttrOfLawNum,
    LawBody: defaultAttrOfLawBody,
    LawTitle: defaultAttrOfLawTitle,
    EnactStatement: defaultAttrOfEnactStatement,
    TOC: defaultAttrOfTOC,
    TOCLabel: defaultAttrOfTOCLabel,
    TOCPreambleLabel: defaultAttrOfTOCPreambleLabel,
    TOCPart: defaultAttrOfTOCPart,
    TOCChapter: defaultAttrOfTOCChapter,
    TOCSection: defaultAttrOfTOCSection,
    TOCSubsection: defaultAttrOfTOCSubsection,
    TOCDivision: defaultAttrOfTOCDivision,
    TOCArticle: defaultAttrOfTOCArticle,
    TOCSupplProvision: defaultAttrOfTOCSupplProvision,
    TOCAppdxTableLabel: defaultAttrOfTOCAppdxTableLabel,
    ArticleRange: defaultAttrOfArticleRange,
    Preamble: defaultAttrOfPreamble,
    MainProvision: defaultAttrOfMainProvision,
    Part: defaultAttrOfPart,
    PartTitle: defaultAttrOfPartTitle,
    Chapter: defaultAttrOfChapter,
    ChapterTitle: defaultAttrOfChapterTitle,
    Section: defaultAttrOfSection,
    SectionTitle: defaultAttrOfSectionTitle,
    Subsection: defaultAttrOfSubsection,
    SubsectionTitle: defaultAttrOfSubsectionTitle,
    Division: defaultAttrOfDivision,
    DivisionTitle: defaultAttrOfDivisionTitle,
    Article: defaultAttrOfArticle,
    ArticleTitle: defaultAttrOfArticleTitle,
    ArticleCaption: defaultAttrOfArticleCaption,
    Paragraph: defaultAttrOfParagraph,
    ParagraphCaption: defaultAttrOfParagraphCaption,
    ParagraphNum: defaultAttrOfParagraphNum,
    ParagraphSentence: defaultAttrOfParagraphSentence,
    SupplNote: defaultAttrOfSupplNote,
    AmendProvision: defaultAttrOfAmendProvision,
    AmendProvisionSentence: defaultAttrOfAmendProvisionSentence,
    NewProvision: defaultAttrOfNewProvision,
    Class: defaultAttrOfClass,
    ClassTitle: defaultAttrOfClassTitle,
    ClassSentence: defaultAttrOfClassSentence,
    Item: defaultAttrOfItem,
    ItemTitle: defaultAttrOfItemTitle,
    ItemSentence: defaultAttrOfItemSentence,
    Subitem1: defaultAttrOfSubitem1,
    Subitem1Title: defaultAttrOfSubitem1Title,
    Subitem1Sentence: defaultAttrOfSubitem1Sentence,
    Subitem2: defaultAttrOfSubitem2,
    Subitem2Title: defaultAttrOfSubitem2Title,
    Subitem2Sentence: defaultAttrOfSubitem2Sentence,
    Subitem3: defaultAttrOfSubitem3,
    Subitem3Title: defaultAttrOfSubitem3Title,
    Subitem3Sentence: defaultAttrOfSubitem3Sentence,
    Subitem4: defaultAttrOfSubitem4,
    Subitem4Title: defaultAttrOfSubitem4Title,
    Subitem4Sentence: defaultAttrOfSubitem4Sentence,
    Subitem5: defaultAttrOfSubitem5,
    Subitem5Title: defaultAttrOfSubitem5Title,
    Subitem5Sentence: defaultAttrOfSubitem5Sentence,
    Subitem6: defaultAttrOfSubitem6,
    Subitem6Title: defaultAttrOfSubitem6Title,
    Subitem6Sentence: defaultAttrOfSubitem6Sentence,
    Subitem7: defaultAttrOfSubitem7,
    Subitem7Title: defaultAttrOfSubitem7Title,
    Subitem7Sentence: defaultAttrOfSubitem7Sentence,
    Subitem8: defaultAttrOfSubitem8,
    Subitem8Title: defaultAttrOfSubitem8Title,
    Subitem8Sentence: defaultAttrOfSubitem8Sentence,
    Subitem9: defaultAttrOfSubitem9,
    Subitem9Title: defaultAttrOfSubitem9Title,
    Subitem9Sentence: defaultAttrOfSubitem9Sentence,
    Subitem10: defaultAttrOfSubitem10,
    Subitem10Title: defaultAttrOfSubitem10Title,
    Subitem10Sentence: defaultAttrOfSubitem10Sentence,
    Sentence: defaultAttrOfSentence,
    Column: defaultAttrOfColumn,
    SupplProvision: defaultAttrOfSupplProvision,
    SupplProvisionLabel: defaultAttrOfSupplProvisionLabel,
    SupplProvisionAppdxTable: defaultAttrOfSupplProvisionAppdxTable,
    SupplProvisionAppdxTableTitle: defaultAttrOfSupplProvisionAppdxTableTitle,
    SupplProvisionAppdxStyle: defaultAttrOfSupplProvisionAppdxStyle,
    SupplProvisionAppdxStyleTitle: defaultAttrOfSupplProvisionAppdxStyleTitle,
    SupplProvisionAppdx: defaultAttrOfSupplProvisionAppdx,
    AppdxTable: defaultAttrOfAppdxTable,
    AppdxTableTitle: defaultAttrOfAppdxTableTitle,
    AppdxNote: defaultAttrOfAppdxNote,
    AppdxNoteTitle: defaultAttrOfAppdxNoteTitle,
    AppdxStyle: defaultAttrOfAppdxStyle,
    AppdxStyleTitle: defaultAttrOfAppdxStyleTitle,
    AppdxFormat: defaultAttrOfAppdxFormat,
    AppdxFormatTitle: defaultAttrOfAppdxFormatTitle,
    Appdx: defaultAttrOfAppdx,
    ArithFormulaNum: defaultAttrOfArithFormulaNum,
    ArithFormula: defaultAttrOfArithFormula,
    AppdxFig: defaultAttrOfAppdxFig,
    AppdxFigTitle: defaultAttrOfAppdxFigTitle,
    TableStruct: defaultAttrOfTableStruct,
    TableStructTitle: defaultAttrOfTableStructTitle,
    Table: defaultAttrOfTable,
    TableRow: defaultAttrOfTableRow,
    TableHeaderRow: defaultAttrOfTableHeaderRow,
    TableHeaderColumn: defaultAttrOfTableHeaderColumn,
    TableColumn: defaultAttrOfTableColumn,
    FigStruct: defaultAttrOfFigStruct,
    FigStructTitle: defaultAttrOfFigStructTitle,
    Fig: defaultAttrOfFig,
    NoteStruct: defaultAttrOfNoteStruct,
    NoteStructTitle: defaultAttrOfNoteStructTitle,
    Note: defaultAttrOfNote,
    StyleStruct: defaultAttrOfStyleStruct,
    StyleStructTitle: defaultAttrOfStyleStructTitle,
    Style: defaultAttrOfStyle,
    FormatStruct: defaultAttrOfFormatStruct,
    FormatStructTitle: defaultAttrOfFormatStructTitle,
    Format: defaultAttrOfFormat,
    RelatedArticleNum: defaultAttrOfRelatedArticleNum,
    Remarks: defaultAttrOfRemarks,
    RemarksLabel: defaultAttrOfRemarksLabel,
    List: defaultAttrOfList,
    ListSentence: defaultAttrOfListSentence,
    Sublist1: defaultAttrOfSublist1,
    Sublist1Sentence: defaultAttrOfSublist1Sentence,
    Sublist2: defaultAttrOfSublist2,
    Sublist2Sentence: defaultAttrOfSublist2Sentence,
    Sublist3: defaultAttrOfSublist3,
    Sublist3Sentence: defaultAttrOfSublist3Sentence,
    QuoteStruct: defaultAttrOfQuoteStruct,
    Ruby: defaultAttrOfRuby,
    Rt: defaultAttrOfRt,
    Line: defaultAttrOfLine,
    Sup: defaultAttrOfSup,
    Sub: defaultAttrOfSub,
};
const newStdEL = (tag, attr, children, range = null) => {
    return new el_1.EL(tag, attr, children, range);
};
exports.newStdEL = newStdEL;
const isStdEL = (obj, tag) => {
    if (typeof obj === "string") {
        return false;
    }
    else if (!(obj instanceof el_1.EL)) {
        return false;
    }
    else if (tag === undefined) {
        return exports.stdELTags.includes(obj.tag);
    }
    else if (Array.isArray(tag)) {
        return tag.includes(obj.tag);
    }
    else {
        return obj.tag === tag;
    }
};
exports.isStdEL = isStdEL;
const makeIsStdEL = (tag) => (obj) => (0, exports.isStdEL)(obj, tag);
exports.makeIsStdEL = makeIsStdEL;
//# sourceMappingURL=stdEL.js.map